module.exports = __webpack_public_path__ + "static/insert_date_1-8cb1776d9c6b5c0707ab7e1435d4a5b8.png";